
interface Props {
    isChecked: boolean
    setIsChecked: (value: boolean) => void
}
const SwitchButtom = ({ isChecked, setIsChecked }: Props) => {

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked)
    }
    return (
        <div className="w-12 h-6 relative">
            <input type="checkbox" checked={isChecked} onChange={handleCheckboxChange} className="custom_switch absolute w-full h-full opacity-0 z-10 cursor-pointer peer" id="custom_switch_checkbox1" />
            <span className="outline_checkbox bg-icon border-2 border-[#71717a] dark:border-white-dark block h-full rounded-full before:absolute before:left-1 before:bg-[#71717a] dark:before:bg-white-dark before:bottom-1 before:w-4 before:h-4 before:rounded-full before:bg-[url(assets/icons/ic_close_switch_buttom.svg)] before:bg-no-repeat before:bg-center peer-checked:before:left-7 peer-checked:before:bg-[url(assets/icons/ic_check_switch_buttom.svg)] peer-checked:border-primary peer-checked:before:bg-primary before:transition-all before:duration-300"></span>
        </div>
    )
}

export default SwitchButtom
